import React from 'react';
import { HomeBanner, HomeBannerProps } from '../../components/home/HomeBanner';
import { MilitaryScholarship, MilitaryScholarshipProps } from '../../components/home/MilitaryScholarship';
import { Partners, PartnersProps } from '../../components/home/Partners';
import { FinancialAid, FinancialAidProps } from '../../components/home/FinancialAid';
import { CoursesThatFit, ACTSectionProps, FundamentalsProps } from '../../components/home/CoursesThatFit';
import { Testimonial, TestimonialProps } from '../../components/common/Testimonial';
import { WhyChoose, WhyChooseProps } from '../../components/home/WhyChoose';
import { HomeCareerNextStep, HomeCareerNextStepProps } from '../../components/home/HomeCareerNextStep';

interface HomeProps {
    homeBanner: HomeBannerProps;
    militaryScholarship: MilitaryScholarshipProps;
    testimonial: TestimonialProps;
    whyChoose: WhyChooseProps;
    partners: PartnersProps;
    financialAid: FinancialAidProps;
    actSection: ACTSectionProps;
    fundamentals: FundamentalsProps;
    careerNextStep: HomeCareerNextStepProps;
}

const Home: React.FC<HomeProps> = ({
    homeBanner,
    militaryScholarship,
    whyChoose,
    testimonial,
    partners,
    financialAid,
    actSection,
    fundamentals,
    careerNextStep,
}) => {
    return (
        <>
            <HomeBanner {...homeBanner} />
            <CoursesThatFit actSection={actSection} fundamentals={fundamentals} />
            <MilitaryScholarship {...militaryScholarship} />
            <WhyChoose {...whyChoose} />
            <Testimonial {...testimonial} />
            <Partners {...partners} />
            <FinancialAid {...financialAid} />
            <HomeCareerNextStep {...careerNextStep} />
        </>
    );
};

export { Home, HomeProps };
